import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
var lastDate = '';

var monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var monthGroup = [];
var compare = function compare(a, b) {
  if (a.year < b.year) {
    return -1;
  }
  if (a.year > b.year) {
    return 1;
  }
  if (a.year === b.year) {
    if (a.month > b.month) {
      return 1;
    }
    if (a.month < b.month) {
      return -1;
    }
    return 0;
  }
};
export default {
  name: 'app',
  components: {},
  methods: {
    displayStyle: function displayStyle(iEstStartDate, iEstFinishDate) {
      var totalDayInProject = this.getMaxDayOfProject();
      var firstMonth = monthGroup[0];
      var firstDateOfFirstMonth = moment(firstMonth.year + '-' + (firstMonth.month + 1) + '-1');
      var startDateInTask = moment(iEstStartDate);
      var endDateInTask = moment(iEstFinishDate);
      var totalDayInTask = startDateInTask.diff(endDateInTask, 'day', true) * -1 + 1;

      var diftFromFirst = startDateInTask.diff(firstDateOfFirstMonth, 'day', true);
      var grantWith = totalDayInTask / totalDayInProject * 100;
      var grantLeft = diftFromFirst / totalDayInProject * 100;

      return {
        width: grantWith + '%',
        left: grantLeft + '%'
      };
    },
    displayDate: function displayDate(addMonth) {
      var month = monthGroup[addMonth];
      return monthArray[month.month];
    },
    makeDate: function makeDate(date) {
      var startDate = moment(date);
      if (!startDate.isValid()) {
        return;
      }
      var name = startDate.year() + '-' + startDate.month();
      var dayInMonth = startDate.daysInMonth();
      var find = monthGroup.filter(function (o) {
        return o.name === name;
      });
      if (find.length === 0) {
        var group = {
          name: startDate.year() + '-' + startDate.month(),
          year: startDate.year(),
          month: startDate.month(),
          maxDay: dayInMonth
        };
        monthGroup.push(group);
      }
    },
    getMaxDayOfProject: function getMaxDayOfProject() {
      var o = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(monthGroup), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var g = _step.value;

          o += g.maxDay;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return o;
    },
    reloadData: function reloadData() {
      monthGroup = [];
      var dateArray = [];
      if (this.tasks === undefined || this.tasks === null || this.tasks.lengh === 0) {
        return dateArray;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(this.tasks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var date = _step2.value;

          this.makeDate(date.estStartDate);
          this.makeDate(date.estFinishDate);
          lastDate = date.estFinishDate;
          if (this.isShowActual === 'Yes') {
            this.makeDate(date.actStartDate);
            this.makeDate(date.actFinishDate);
            lastDate = date.actFinishDate;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      monthGroup.sort(compare);
      var first = monthGroup[0];
      var lastMonth = monthGroup[monthGroup.length - 1];

      var firstMoment = moment({ y: first.year, M: first.month, d: 1 });
      var lastMoment = moment({ y: lastMonth.year, M: lastMonth.month, d: 1 });

      var diffMonths = firstMoment.diff(lastMoment, 'months') * -1 + 1;
      if (monthGroup.length !== diffMonths) {
        monthGroup = [];
        for (var i = 0; i < diffMonths; i++) {
          var monthAdd = i === 0 ? 0 : 1;
          var f = firstMoment.add(monthAdd, 'months');
          this.makeDate(f.toString('YYYY-MM-DD'));
        }
      }
      // console.log(monthGroup)
    },
    calTotalMonth: function calTotalMonth() {
      return monthGroup.length;
    }
  },

  props: ['tasks', 'isShowActual'],
  computed: {},
  watch: {
    tasks: {
      handler: function handler(newValue) {
        this.reloadData();
        this.totalMonth = this.calTotalMonth();
        this.lastDate = lastDate;
      },
      deep: true
    }
  },
  beforeMount: function beforeMount() {},
  data: function data() {
    var taskLength = this.tasks.length;
    this.reloadData();

    var totalMonth = this.calTotalMonth();
    return {
      totalMonth: totalMonth,
      lastDate: lastDate,
      taskLength: taskLength
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/grantchartQU.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/grantchartQU.vue
// module chunks = 0 1 30 31 43